export default __webpack_public_path__ + "media/images/favicon/favicon.svg";